import React from "react";
import Header from "./Header/Header";
import Top from "./Top/Top";

function ContentBlock(props) {
    const { type } = props;
    if (type === "menu_page_header") return <Header {...props} />;
    else return <Top {...props} />;
};

export default ContentBlock;
